import styled from "styled-components"

export const NavButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;
  color: ${props => props.theme.lightGrey2};
  display: flex;

  :hover {
    color: ${props => props.theme.red};
  }

  padding: 0;
`
